// src/lib/contacts/locationFormat.ts
import type { LocationResult } from "./router";

export function formatLocationAnswer(q: string, rows: LocationResult[]): string {
  if (!rows.length) {
    return `I couldn’t find a matching office location for: “${q}”. Try the city or office name, or include the word “location”.`;
  }

  const r = rows[0];

  const line1 = `${r.location || "Unknown Location"}${r.company ? ` (${r.company})` : ""}`;
  const addr = [r.address, r.city, r.state, r.zip].filter(Boolean).join(", ");

  const parts: string[] = [];
  if (addr) parts.push(`Address: ${addr}`);
  if (r.office) parts.push(`Office: ${r.office}`);
  if (r.email) parts.push(`Email: ${r.email}`);
  if (r.salespersons) parts.push(`Salespersons: ${r.salespersons}`);
  if (parts.length === 0) {
    parts.push("No additional contact details were found for this location.");
  }

  if ((q || "").toLowerCase().includes("manager")) {
    parts.push(
      `For a specific person or manager, ask something like “Who do I contact about …?” or “Who works at ${r.location || "this office"}?” to open the contact directory.`
    );
  }

  return [line1, ...parts].join("\n");
}